import { usePaginatedQuery } from 'hooks/usePaginatedQuery'
import { TLocationList } from 'shared/types'
import { api } from '..'

export const getLocationList = (params?: Record<string, string>) =>
  api
    .get<TLocationList>('/v1/locations', {
      params,
    })
    .then(({ data }) => data)

export const locationListQuery = (params?: Record<string, string>) => ({
  queryFn: () => getLocationList(params),
  queryKey: ['locations', params],
})

export const locationListHelper = {
  queryFn: () =>
    getLocationList({ results: '100' }).then(data =>
      data?.items?.map?.(location => ({
        value: location.id,
        label: location.name,
      })),
    ),
  queryKey: ['locations', 'helper'],
}

export const useGetLocationList = () => usePaginatedQuery(locationListQuery)
